import { InfoCircle, QuestionCircle } from "react-bootstrap-icons";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import styles from "./HelpTooltip.module.scss";

interface Props {
  text: string;
  side?: "top" | "bottom" | "left" | "right";
  variant?: "info" | "help";
}

export default function HelpTooltip({
  text,
  side = "top",
  variant = "help",
}: Props) {
  const icon =
    variant === "help" ? (
      <QuestionCircle size={16} style={{ marginTop: "2px" }} />
    ) : variant === "info" ? (
      <InfoCircle size={16} />
    ) : null;

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={styles.helpButton}>{icon}</span>
        </TooltipTrigger>
        <TooltipContent side={side}>{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
